import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	contact: {},
	name: {
		color: theme.palette.getContrastText(theme.palette?.background?.footer),
		marginBottom: theme.spacing(1)
	},
	addition: {
		color: theme.palette.getContrastText(theme.palette?.background?.footer)
	},
	street: {
		color: theme.palette.getContrastText(theme.palette?.background?.footer)
	},
	city: {
		color: theme.palette.getContrastText(theme.palette?.background?.footer)
	},
	country: {
		color: theme.palette.getContrastText(theme.palette?.background?.footer)
	},
	phonePrivate: {
		display: "flex",
		marginTop: theme.spacing(1)
	},
	phone: {
		display: "flex",
		marginTop: theme.spacing(5)
	},
	mail: {
		display: "flex",
		marginTop: theme.spacing(1)
	},
	whatsapp: {
		display: "flex",
		marginTop: theme.spacing(1)
	},
	icon: {
		alignItems: "center",
		background: theme.palette.grey[500],
		display: "flex",
		flex: "40px 0 0",
		height: 40,
		justifyContent: "center",
		transition: "background 250ms ease",
		width: 40,
		"& svg path": {
			fill: "#FFFFFF !important"
		}
	},
	link: {
		alignItems: "flex-start",
		color: theme.palette.getContrastText(theme.palette?.background?.footer),
		display: "flex",
		gap: theme.spacing(2),
		"& .mco-typography": {
			wordBreak: "break-all"
		},
		"&:hover": {
			"& .mco-view-component-footer-contact__icon": {
				background: theme.palette.grey[700]
			}
		},
		"& div.mco-typography": {
			lineHeight: "1.3",
			paddingTop: 6
		}
	},
	linkAddition: {
		display: "block"
	},
	socialIcons: {
		marginTop: theme.spacing(6)
	},
	socialIconsTitle: {
		marginBottom: theme.spacing(2)
	}
}));

export default styles;
